import { useEffect, useState } from "react";

/**
 * Mobil (dar ekran) kırılım noktası — PROJE STANDARDI. Bunun ALTI telefon/dar tablet:
 * off-canvas nav + tablo yerine kart. CSS media query'leri de `max-width: 767.98px` kullanır
 * (media query koşulunda CSS değişkeni kullanılamaz → sabit; tek yerde tanımlı).
 */
export const MOBILE_BREAKPOINT = 768;

/** matchMedia tabanlı — dar ekranda `true`. Ekran döndürme/yeniden boyutlandırmada güncellenir. */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT): boolean {
  const query = `(max-width: ${breakpoint - 0.02}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return isMobile;
}
